export default __webpack_public_path__ + "static/resumelong-455ea463126f5e6a0a99f2c4f9fa6560.pdf";